// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.before-plan-subscription {
  margin-top: 16px;
  margin-bottom: 16px;
  font-size: 10px;
  font-weight: 400;
  line-height: 15.6px;
  letter-spacing: 0.02em;
  text-align: center;
  color: var(--dark-gray);
}

.before-plan-subscription.bold {
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.before-plan-subscription.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".before-plan-subscription {\n  margin-top: 16px;\n  margin-bottom: 16px;\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 15.6px;\n  letter-spacing: 0.02em;\n  text-align: center;\n  color: var(--dark-gray);\n}\n\n.before-plan-subscription.bold {\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
